<p-dialog
  [header]="ModalService.title"
  [(visible)]="ModalService.isVisible"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '40vw' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeModal()"r

>
  <div [innerHTML]="ModalService.message"></div>  @if (ModalService.showButtons) {
  <div class="modal-base__buttons">
    <p-button
      [label]="'transversales.agreeButtonLabel' | translate"
      (click)="closeModal()"
      class="button-base"
    ></p-button>
  </div>
  }
</p-dialog>
